import { EVENT_PREFIX } from './constants';
/**
 * Saves current progress into window object and emits CustomEvent
 * @param {Object} config Object holding necessary constants
 * @param {('start'|'done'|'error')} state Event describing current state
 * @param {Object} data Data to be saved to window and emitted with event
 */
const status = (config, state, data) => {
    const { name } = config;
    const EVENT_TYPE = `${EVENT_PREFIX}${name}`;
    const detail = Object.assign({ state }, data);
    // Add to window
    window.sznIVA = window.sznIVA || {};
    window.sznIVA[name] = window.sznIVA[name] || {};
    // Overwrite data, but do not remove any properties
    Object.assign(window.sznIVA[name], detail);
    // Emit CustomEvent
    const event = new CustomEvent(EVENT_TYPE, { detail });
    window.dispatchEvent(event);
};
export { status };
